export default "__VITE_ASSET__CPiTf2I7__"